























































import Vue from 'vue';
import Component from 'vue-class-component';
import ResponsiveImage from '@/common/vue/ResponsiveImage.vue';
import MainNavigationItem from '@/webcomponents/header/MainNavigationItem.vue';
import SubNavigation from '@/webcomponents/header/components/SubNavigation.vue';
import SubNavigationItem from '@/webcomponents/header/SubNavigationItem.vue';
import HeaderFlyoutContent from '@/webcomponents/header/components/HeaderFlyoutContent.vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import LoginFlyout from '@/webcomponents/header/components/LoginFlyout.vue';

const IconArrowLeft = () => import('@/common/icons/arrow-right.svg');

const HeaderMobileMenuProps = Vue.extend({
  props: {
    headerHeight: String,
    privacyActionName: String,
  },
});

@Component({
  components: {
    LoginFlyout,
    HeaderFlyoutContent,
    SubNavigation,
    ResponsiveImage,
    IconArrowLeft,
  },
})
export default class HeaderMobileMenu extends HeaderMobileMenuProps {
  $refs!: {
    scrollContainer: HTMLElement;
  };

  activeMainNavItem: MainNavigationItem | null = null;
  activeSubNavItem: SubNavigationItem | null = null;
  fadeInMenu = false;
  fadeInFromLeft = false;
  fadeInFromRight = false;
  fadeOutToLeft = false;
  fadeOutToRight = false;
  flyoutContent: string | null = null;
  nextFlyoutContent: string | null = null;
  nextMenuItem: MainNavigationItem | SubNavigationItem | null = null;
  imageItemCount = 0;
  listItemCount = 0;
  transitionComplete = false;
  transitionRunning = false;

  // close mobile menu
  handleTransitionEnd () {
    if (!this.fadeInMenu) {
      this.activeSubNavItem = null;
      this.activeMainNavItem = null;

      this.$emit('on-menu-close');
    }
  }

  onNavClick (evt: any) {
    if (evt?.detail?.clickedItem) {
      const nextMenuItem: MainNavigationItem | SubNavigationItem = evt.detail.clickedItem;
      this.handleNavChange(nextMenuItem);
    }
  }

  onNavBack () {
    if (this.activeSubNavItem && this.activeMainNavItem) {
      this.handleNavChange(this.activeMainNavItem);
    } else if (this.activeMainNavItem) {
      this.fadeOut(false);
    }
  }

  handleNavChange (nextMenuItem: MainNavigationItem | SubNavigationItem) {
    if (!this.transitionRunning) {
      this.transitionComplete = false;
      this.nextMenuItem = nextMenuItem;

      const nextIsMainNav = 'subNavigationItems' in nextMenuItem;
      const fadeOutToLeft = (!this.activeMainNavItem && nextIsMainNav) || !this.activeSubNavItem;

      this.fadeOut(fadeOutToLeft);
      this.loadMenuContent();
    }
  }

  fadeOut (toLeft = true) {
    this.fadeInFromLeft = false;
    this.fadeInFromRight = false;
    this.fadeOutToLeft = toLeft;
    this.fadeOutToRight = !toLeft;
  }

  resetFade () {
    this.fadeInFromLeft = false;
    this.fadeInFromRight = false;
    this.fadeOutToLeft = false;
    this.fadeOutToRight = false;
  }

  completeFade () {
    let isRelevantTransition = false;
    if (this.fadeOutToLeft) {
      this.fadeOutToLeft = false;
      this.fadeInFromRight = true;
      isRelevantTransition = true;
    } else if (this.fadeOutToRight) {
      this.fadeOutToRight = false;
      this.fadeInFromLeft = true;
      isRelevantTransition = true;
    }

    if (isRelevantTransition) {
      this.transitionComplete = true;
      this.completeChange();
    }
    this.transitionRunning = false;
  }

  completeChange (): void {
    if (this.transitionComplete && this.nextFlyoutContent && this.nextMenuItem) {
      if ('subNavigationItems' in this.nextMenuItem) {
        this.activeMainNavItem = this.nextMenuItem;
        this.activeSubNavItem = null;
      } else {
        this.activeSubNavItem = this.nextMenuItem;
      }

      this.displayMenuContent(this.nextFlyoutContent);

      this.transitionComplete = false;
      this.nextFlyoutContent = null;
      this.nextMenuItem = null;

      setTimeout(() => {
        this.resetFade();
      }, 25);
    } else if (this.transitionComplete && !this.nextMenuItem) {
      this.activeMainNavItem = null;
      this.activeSubNavItem = null;
      this.transitionComplete = false;

      setTimeout(() => {
        this.resetFade();
      }, 25);
    }
  }

  onLegalLinkClick () {
    this.enableScroll();
    const event = new CustomEvent('legalLinkClicked', {
      bubbles: true,
      composed: true,
      detail: this.privacyActionName,
    });
    this.$el.dispatchEvent(event);
  }

  closeOverlay () {
    this.fadeInMenu = false;
  }

  loadMenuContent () {
    if (this.nextMenuItem && this.nextMenuItem.flyoutUrl) {
      fetch(this.nextMenuItem.flyoutUrl)
        .then((response) => response.text())
        .then((data) => {
          this.nextFlyoutContent = data;
          this.completeChange();
        });
    }
  }

  displayMenuContent (data: string) {
    const html = document.createElement('div');
    html.innerHTML = data;
    this.imageItemCount = html.querySelectorAll('.headerflyout .headerflyoutimageitem').length;
    this.listItemCount = html.querySelectorAll('.headerflyout .headerflyoutlistitem').length;
    this.flyoutContent = html.querySelector('.headerflyout')?.innerHTML || null;
  }

  disableScroll () {
    disableBodyScroll(this.$refs.scrollContainer);
  }

  enableScroll () {
    enableBodyScroll(this.$refs.scrollContainer);
  }

  get showSubnavigation (): boolean {
    return !this.activeSubNavItem
      && !!this.activeMainNavItem
      && this.activeMainNavItem.subNavigationItems.length > 0;
  }

  get subNavItems (): SubNavigationItem[] | null {
    if (this.activeMainNavItem) {
      return this.activeMainNavItem.subNavigationItems.items;
    }
    return null;
  }

  get activeNavItemText () {
    if (this.activeSubNavItem) {
      return this.activeSubNavItem.itemText;
    }

    if (this.activeMainNavItem) {
      return this.activeMainNavItem.itemText;
    }

    return null;
  }

  get rootClass () {
    return {
      'brandhub-header-mobile-menu--menu-in': this.fadeInMenu,
      'brandhub-header-mobile-menu--in-from-left': this.fadeInFromLeft,
      'brandhub-header-mobile-menu--in-from-right': this.fadeInFromRight,
      'brandhub-header-mobile-menu--out-to-left': this.fadeOutToLeft,
      'brandhub-header-mobile-menu--out-to-right': this.fadeOutToRight,
    };
  }

  mounted () {
    this.$el.addEventListener('mainNavClicked', this.onNavClick);
    window.document.addEventListener('closeLegalLayer', this.disableScroll);

    setTimeout(() => {
      this.fadeInMenu = true;
    }, 20);

    this.disableScroll();
  }

  beforeDestroy () {
    this.$el.removeEventListener('mainNavClicked', this.onNavClick);
    window.document.removeEventListener('closeLegalLayer', this.disableScroll);
    this.enableScroll();
  }
}
